import type { ChangeEventHandler } from 'react';
import ProfileImage from './ProfileImage';

interface ProfileImageFormProps {
  onChange: ChangeEventHandler<HTMLInputElement>;
  submitting?: boolean;
  user: {
    name: string;
    photo_url?: string;
  };
}

const ProfileImageForm = ({ onChange, submitting = false, user }: ProfileImageFormProps) => (
  <>
    <div className="col-md-12 d-flex justify-content-center">
      <ProfileImage large photoUrl={user.photo_url} userName={user.name} />
    </div>
    <div className="col-md-12 text-center">
      <form>
        <label htmlFor="profile-image" className="btn btn-primary-dark btn-upload fw-bold">
          Select new photo
          <input
            accept="image/*"
            className="form-control"
            data-testid="users-profile-image-form-input"
            disabled={submitting}
            id="profile-image"
            name="photo"
            onChange={onChange}
            type="file"
          />
        </label>
      </form>
    </div>
  </>
);

export default ProfileImageForm;
